const AUTH_FAILURE_SOURCE_KEY = 'samaAuthFailureSource';
const EXTERNAL_SERVICE_SOURCE = 'external-service';

const getUrlBase = () => (
  typeof window !== 'undefined' && window.location?.origin
    ? window.location.origin
    : 'http://localhost'
);

const parseRequestUrl = (value) => {
  try {
    return new URL(String(value || ''), getUrlBase());
  } catch {
    return null;
  }
};

const pathMatchesBase = (pathname, basePathname) => {
  const normalizedBase = String(basePathname || '').replace(/\/+$/, '');
  return Boolean(
    normalizedBase
    && (pathname === normalizedBase || pathname.startsWith(`${normalizedBase}/`))
  );
};

export const isFirstPartyApiRequestUrl = (url, firstPartyApiBaseUrl) => {
  const requestUrl = parseRequestUrl(url);
  const apiUrl = parseRequestUrl(firstPartyApiBaseUrl);
  if (!requestUrl || !apiUrl) return false;

  return requestUrl.origin === apiUrl.origin
    && pathMatchesBase(requestUrl.pathname, apiUrl.pathname);
};

export const withExternalServiceAuthPolicy = (config = {}) => ({
  ...config,
  [AUTH_FAILURE_SOURCE_KEY]: EXTERNAL_SERVICE_SOURCE,
});

const isUpstreamServiceError = (data) => {
  const code = String(data?.code || '').trim().toUpperCase();
  const source = String(data?.source || '').trim().toLowerCase();
  return code === 'AI_UPSTREAM_ERROR'
    || code === 'PEOPLE_COUNTER_UPSTREAM_ERROR'
    || code === 'UPSTREAM_SERVICE_ERROR'
    || source === 'ai_report_service'
    || source === 'ai_service'
    || source === 'people_counter_service';
};

export const shouldInvalidateSessionForError = (error, firstPartyApiBaseUrl) => {
  const status = Number(error?.response?.status);
  if (status !== 401 && status !== 403) return false;
  if (error?.config?.[AUTH_FAILURE_SOURCE_KEY] === EXTERNAL_SERVICE_SOURCE) return false;
  if (isUpstreamServiceError(error?.response?.data)) return false;
  return isFirstPartyApiRequestUrl(error?.config?.url, firstPartyApiBaseUrl);
};
